import { PartyIdentifierDTO } from 'support/types';

const PRIORITY: ReadonlyArray<PartyIdentifierDTO['domain']> = ['GS1', 'vatID', 'internal'];

export const orderIdentifiers = (identifiers: ReadonlyArray<PartyIdentifierDTO>): Array<PartyIdentifierDTO> => {
  const prioritized: Array<PartyIdentifierDTO> = [];
  const remaining: Array<PartyIdentifierDTO> = [];

  for (const item of identifiers) {
    if (PRIORITY.includes(item.domain)) {
      prioritized.push(item);
    } else {
      remaining.push(item);
    }
  }

  prioritized.sort((a, b) => PRIORITY.indexOf(a.domain) - PRIORITY.indexOf(b.domain));
  return [...prioritized, ...remaining];
};
